import { BaseEntity } from '../../../models';
import { UnidadeNegocio } from '../unidade-negocio';
import { NaturezaVenda } from '../../natureza-venda';

export class UnidadeNegocioNaturezaVenda implements BaseEntity {
    readonly id: number;
    idUnidadeNegocio: number;
    unidadeNegocio: UnidadeNegocio;
    idNaturezaVenda: number;
    naturezaVenda: NaturezaVenda;
    cotacaoItemFormulario: number;
}
